export const CustomerModel = {
  id: null,
  name: '',
  invoice_no: '',
  address: '',
  telephone: '',
  is_active: true
}